import apiClient from '../../api/apiClient';
import { API_ENDPOINTS } from '../../api/endPoints';
import { Publisher, PublisherFilter, PublisherFormData } from '../../types/publisher.types';

export const getPublishers = async (): Promise<Publisher[]> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.PUBLISHERS.LIST);
  return response.data;
};

export const getFilteredPublishers = async (filters: PublisherFilter): Promise<Publisher[]> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.PUBLISHERS.FILTER, {
    params: filters,
  });
  return response.data;
};

export const getPublisherById = async (id: string): Promise<Publisher> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.PUBLISHERS.DETAIL(id));
  return response.data;
};

export const createNewPublisher = async (data: PublisherFormData): Promise<Publisher> => {
  const response = await apiClient.post(API_ENDPOINTS.PUBLISHER.PUBLISHERS.CREATE, data);
  return response.data;
};

export const updateExistingPublisher = async (id: string, data: PublisherFormData): Promise<Publisher> => {
  const response = await apiClient.put(API_ENDPOINTS.PUBLISHER.PUBLISHERS.UPDATE(id), data);
  return response.data;
};

export const deleteExistingPublisher = async (id: string): Promise<void> => {
  await apiClient.delete(API_ENDPOINTS.PUBLISHER.PUBLISHERS.DELETE(id));
};

export const AIGenerateCssSelectors = async (
  websiteId: string,
  headlinesUrl: string
) => {
//   const fakeResponse = `{
//     "selectors": {
//         "articleContainer": "article.category-newsletter",
//         "headline": ".entry-title a",
//         "publishDate": ".entry-meta time.entry-date",
//         "articleUrl": ".entry-title a[href]",
//         "image": "",
//         "category": "article.category-newsletter",
//         "fullArticleContent": "",
//         "fullArticleImage": "",
//         "author": "",
//         "subheadline": "",
//         "content": ".entry-wrapper > p"
//     }
// }`;
//   return JSON.parse(fakeResponse);
  try {
    const url = API_ENDPOINTS.PUBLISHER.WEBSITES.AI_SELECTORS(websiteId);
    const response = await apiClient.get(url, {params: { headlinesUrl }});
    return response.data;
  } catch (error) {
    console.error("Error testing studio configuration:", error);
    throw error;
  }
};

// NEW: Publisher pronunciation rules APIs
export const createPronunciationRuleEntry = async (
  publisherId: string,
  entry: any
): Promise<any> => {
  const url = API_ENDPOINTS.PUBLISHER.PUBLISHERS.PRONUNCIATION.ENTRIES(publisherId);
  const response = await apiClient.post(url, entry);
  return response.data;
};

export const updatePronunciationRuleEntry = async (
  publisherId: string,
  entryId: string,
  entry: any
): Promise<any> => {
  const url = API_ENDPOINTS.PUBLISHER.PUBLISHERS.PRONUNCIATION.ENTRY(publisherId, entryId);
  const response = await apiClient.put(url, entry);
  return response.data;
};

export const deletePronunciationRuleEntry = async (
  publisherId: string,
  entryId: string
): Promise<void> => {
  const url = API_ENDPOINTS.PUBLISHER.PUBLISHERS.PRONUNCIATION.ENTRY(publisherId, entryId);
  await apiClient.delete(url);
};

export const syncPronunciationRules = async (
  publisherId: string
): Promise<any> => {
  const url = API_ENDPOINTS.PUBLISHER.PUBLISHERS.PRONUNCIATION.SYNC(publisherId);
  const response = await apiClient.post(url, {});
  return response.data;
};

// NEW: List pronunciation rule entries
export const listPronunciationRuleEntries = async (publisherId: string): Promise<any[]> => {
  const url = API_ENDPOINTS.PUBLISHER.PUBLISHERS.PRONUNCIATION.ENTRIES(publisherId);
  const response = await apiClient.get(url);
  // Server may return { entries: [...] } or just an array; normalize to array
  const data = response.data;
  return Array.isArray(data) ? data : (data?.entries ?? []);
};